<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="d-flex justify-content-between">
          <div class="section-title">
            {{ $t("Movie Overall Analysis Report") }}
          </div>
          <div class="d-flex align-items-center">
            <div class="d-flex align-item-center">
              <input value="1" type="radio" v-model="lang_id" />
              <span class="ml-1">English</span>
            </div>
            <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id" />
  
              <span class="ml-1">العربية</span>
            </div>
          </div>
        </div>
        <!-- <small
          ><em>{{ $t("* As Per Show Date") }}</em></small
        > -->
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.selectedCinema &&
                    dropDown.selectedCinema.hasOwnProperty('cine_id')
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                  >{{ $t("select") }} {{ $tc("cinema") }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder=""
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedDateType && selectedDateType.hasOwnProperty('value')
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                  >{{ $t("Select Date Type") }}</label
                >
                <multiselect
                  :options="dateTypes"
                  v-model="selectedDateType"
                  placeholder=""
                  label="name"
                  :multiple="false"
                  :close-on-select="true"
                  track-by="value"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                                ✖
                              </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                                ✖
                              </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  >
                  </Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedPaymentSource && selectedPaymentSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("All Payment Mode") }} </label
              >
              <multiselect
                :options="paymentList"
                v-model="selectedPaymentSource"
                placeholder=""
                label="pm_payment_mode"
                :multiple="true"
                :close-on-select="false"
                track-by="pm_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

            <div style="" class=" d-flex  col-lg-3 col-xl-2 mb-2 custom-timepicker">
                  <div class="d-flex justify-content-center ">
                    <vue-timepicker manual-input v-model="start_time" id="starttime" name="starttime"
                      :placeholder="$tc('starttime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll
                      lazy ></vue-timepicker>
                    <!--Tooltip :title="$t('offer_end_time')" /-->
                  </div>
          </div>
          <!-- <div style="border:1px solid red" class=" d-flex  col-lg-3 col-xl-2 mb-2 custom-timepicker">
                  <div style="border:1px solid blue" class="d-flex ">
                    <vue-timepicker manual-input v-model="end_time" id="endtime" name="endtime"
                      :placeholder="$tc('endtime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll
                      lazy ></vue-timepicker>
                  </div>
          </div> -->
          <div class="position-relative col-lg-3 col-xl-2 mb-2 " >
  <vue-timepicker
    manual-input
    v-model="end_time"
    id="endtime"
    name="endtime"
    :placeholder="$tc('endtime')"
    format="HH:mm"
    class="time_picker"
    input-width="100%"
    auto-scroll
    lazy
  />
</div>
            <!-- <div class="col-6 mb-4 align-self-center">
              <div class="d-flex">
                <p class="mb-0 mr-3">{{ $t('fixedValueToTheatre') }}</p>
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="date_type"
                  name="check-button"
                  class="md"
                  switch
                ></b-form-checkbox>
              </div>
            </div> -->
            <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedDistributor.length > 0 ? 'shift-up' : ''">
                  {{ "Distributor" }}
                </label>

                <multiselect v-model="selectedDistributor" @input="onSelectHandler($event, 'distributor')"
                  @remove="onRemoveHandler($event, 'distributor')" placeholder=""
                  :options="getDistributorReportDropdownList" label="d_company_name" track-by="d_id" :multiple="true"
                  name="d_id" id="d_id" select-label="Select" deselect-label="Remove">
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedMovie.length > 0 ? 'shift-up' : ''">
                  {{ "All Movie" }}
                </label>

                <multiselect v-model="selectedMovie" @select="onSelectHandler($event, 'movie')"
                  @remove="onRemoveHandler($event, 'movie')" placeholder="" :options="MovieList" label="movie_title"
                  track-by="md_id" :multiple="true" name="movie_id" id="movie_id" select-label="Select"
                  deselect-label="Remove"
                  :close-on-select="false"
                  >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedScreen && selectedScreen.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("All") }} {{ $t("screens") }}</label
              >
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
        

         
            <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
              <button class="btn-blue-lg w-100" @click="onSubmit">
                {{ $t("fetch") }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="movieData.length > 0"
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
        >
          <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>
  
          <img
            @click="getMovieOverAllAnalysisReport('Y', 'N',false)"
            class="cursor-pointer"
            height="25"
            src="@/assets/img/icons/pdf-icon.svg"
            width="25"
          />
  
          <img
            @click="getMovieOverAllAnalysisReport('N', 'Y',false)"
            class="cursor-pointer ml-1"
            height="25"
            src="@/assets/img/icons/excel.svg"
            width="25"
          />
        </div>
  
        <div class="swc-report">
          <table
            class="swc-report-table"
            :class="
              lang_id == 2
                ? 'swc-report-table reverse-order '
                : 'swc-report-table order '
            "
            border="1"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th>{{ trans("moviename", lang_id) }}</th>
                <th>{{ trans("distributorcompany", lang_id) }}</th>
                <th>{{ trans("totaltickets", lang_id) }}</th>
                <th>{{ trans("totalticketsprice", lang_id) }}</th>
                <th>{{ trans("totaltaxes", lang_id) }}</th>
                <th>{{ trans("totalvat", lang_id) }}</th>
                <th>{{ trans("totalnet", lang_id) }}</th>
              </tr>
            </thead>
            <tbody v-if="movieData.length">
              <tr v-for="movie in movieData">
                <td :class="lang_id==1?'text-left':'text-right'">
                  {{
                    lang_id == 1
                      ? movie.movie_title
                      : movie.movie_title_4
                      ? movie.movie_title_2
                      : movie.movie_title
                  }}
                </td>
                <td :class="lang_id==1?'text-left':'text-right'">{{ movie.dist_company_name }}</td>
                <td class="text-right">{{ movie.tickets_no }}</td>
                <td class="text-right">{{ parseFloat(movie.tickets_gross || 0).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(movie.total_tax || 0).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(movie.total_vat || 0).toFixed(6) }}</td>
                <td class="text-right">{{ parseFloat(movie.tickets_net || 0).toFixed(6) }}</td>
              </tr>
              <tr class="bg-lightgrey">
                  <td :class="lamg_id==1?'text-left':'text-right'"  colspan="2">{{trans("grandtotal",lang_id)}}</td>
                  <td class="text-right">{{ grandTotal.total_tickets  }}</td>
                  <td class="text-right">{{parseFloat(grandTotal.total_ticket_prise || 0).toFixed(6)}}</td>
                  <td class="text-right">{{parseFloat(grandTotal.total_tax || 0).toFixed(6)}}</td>
                  <td class="text-right">{{parseFloat(grandTotal.total_vat || 0).toFixed(6)}}</td>
                  <td class="text-right">{{parseFloat(grandTotal.total_ticket_net || 0).toFixed(6)}}</td>
              </tr>
            </tbody>
   
            <tbody v-else>
              <td colspan="11">No Records</td>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportService from "@/services/ReportsService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import NewReportService from "../../../services/NewReportService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  import { mapState, mapActions ,mapGetters} from "vuex";
  import { authenticationService } from "@/services/AuthenticationService";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import MovieService from "@/services/MovieService";

  // import LangSwitcher from "./LangSwitcher.vue";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
      VueTimepicker
      // LangSwitcher,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        date_type: "Y",
        selectedDateType: {
          name: "As Per Transaction Date",
          value: "transaction_date",
        },
        dateTypes: [
          {
            name: "As Per Transaction Date",
            value: "transaction_date",
          },
          {
            name: "As Per Show Date",
            value: "show_date",
          },
        ],
        submitted: false,
        htmlToPdfOptions: {
          filename: this.pdfFileName,
          margin: 3,
          image: {
            type: "jpeg",
            quality: 1,
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
          },
          jsPDF: {
            format: "a2",
            orientation: "landscape",
          },
        },
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
          selectedCinemaAddres: null,
        },
        start_time:"",
        end_time:"",
        MovieList:[],
        paymentList:[],
        selectedDistributor:[],
        selectedMovie:[],
        selectedPaymentSource:[],
        fromDate: new Date(),
        toDate: new Date(),
        advancedSalesrecords: [],
        grandTotal: {},
        screenData: [],
        showData: [],
        movieData: [],
        Users: [],
        selectedScreen: [],
        selectedUsers: {},
        screenList: [],
        selectedLanguage: "en",
        lang_id: "1",
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      this.fetchReportDistributorsList();
      this.getPaymentTypes();
      // this.getMovieOverAllAnalysisReport("N", "N", true);
      // this.getActiveMovies();
    },
    watch: {
      fromDate() {
    this.getMovieOverAllAnalysisReport("N", "N", true);
  },
  toDate() {
    this.getMovieOverAllAnalysisReport("N", "N", true);
  },
    },
    mounted() {},
    computed: {
        ...mapGetters([
      "getDistributorReportDropdownList"
      //   "getDistributorReportMoviesList",
    ]),
      currentSelectedLanguage() {
        return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
      },
      distributorIds() {
      let text = ``;
      if (this.selectedDistributor.length > 0) {
        text = this.selectedDistributor.map(x => x.d_id).join(",");
      }

      return text;
    },
    movieIds() {
      let text = ``;
      if (this.selectedMovie.length > 0) {
        text = this.selectedMovie.map(x => x.movie_id).join(",");
      }

      return text;
    },
    movieDetailId() {
      let text = ``;
      if (this.selectedMovie.length > 0) {
        text = this.selectedMovie.map(x => x.md_id).join(",");
      }

      return text;
    },
    screenIds() {
      let text = ``;
      if (this.selectedScreen.length > 0) {
        text = this.selectedScreen.map(x => x.screen_id).join(",");
      }

      return text;
    },
    paymentModeId() {
      let text = ``;
      if (this.selectedPaymentSource.length > 0) {
        text = this.selectedPaymentSource.map(x => x.pm_id).join(",");
      }

      return text;
    }
    },
    methods: {
      moment,
      getCinemaList: function () {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.dropDown.selectedCinemaAddres = event.cine_address;
        this.$store.dispatch("selectDropdownCinema", event);
        this.getCinemaScreens();
        this.getMovieOverAllAnalysisReport("N", "N", true);

      },
      onSubmit() {
        this.getMovieOverAllAnalysisReport();
      },
      async getCinemaScreens(index) {
        try {
          const response = await MasterService.GetActiveList({
            tableName: "screens",
            screen_is_active: "Y",
            cinema_id: this.dropDown.selectedCinemaId,
          });
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // this.screenList = data.Records;
            this.screenList = data.Records.sort((a, b) => 
  a.screen_name.toLowerCase().localeCompare(b.screen_name.toLowerCase())
);
          } else {
            console.log("show error:", data.message);
          }
        } catch (error) {
          this._CatchError(error);
        }
      },
  
      async getMovieOverAllAnalysisReport(isPdf = "N", isExcel = "N",filter=false) {
        this.movieData = [];
        this.grandTotal = {};
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.selectedDateType) {
          return this.$toasted.show("Select Date Type");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
      
        let loader;
        try {
          let screen_id = [];
          this.screenData = [];
          if (this.selectedScreen.length) {
            screen_id = this.selectedScreen.map((screen) => screen.screen_id);
          }
          loader = this.$loading.show();
          let payload = {
            cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            cinema_address: this.dropDown.selectedCinemaAddres,
            fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
            lang_id: this.lang_id,
            language: this.selectedLanguage,
            date_type:this.selectedDateType.value,
            d_id:this.distributorIds,
            md_id:this.movieDetailId,
            screen_id:this.screenIds,
            movie_id:this.movieIds,
            payment_mode_id:this.paymentModeId,
            start_time:this.start_time,
            end_time:this.end_time,
            isPdf,
            isExcel,filter
          };
          if (this.selectedUsers && this.selectedUsers.user_id) {
            payload.user_id = this.selectedUsers.user_id;
          }
          let response = await ReportService.GetMovieOverallAnalysisMif(payload);
          const { data } = response;
          if (data.status && data.Records.length) {
          if(filter){
            this.MovieList= data.Records
          }else{
            this.movieData = data.Records;
            this.grandTotal=data.grandTotal;
            if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
          }
          } else {
            this.$toasted.show(data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          if (loader) {
            loader.hide();
          }
        }
      },
      updateLanguage(lang) {
        this.selectedLanguage = lang;
        // console.log("this.selectedLanguage:", this.selectedLanguage);
      },
      onSelectHandler(event,type){
        if (type =="distributor") {
        this.d_id = event.d_id;
        // this.selectedMovie = [];
        // this.MovieList = [];
        // this.fetchDistributorMovies();
        // this.selectedDistributor = event;
      }
      },
      onRemoveHandler(event,type){
        
    },
     getPaymentTypes() {
      const activeRequest = MasterService.GetActiveList({
        tableName: "ms_payment_modes",
        pm_is_active: "Y"
      });
      const elCinemaRequest = MasterService.GetActiveList({
        tableName: "ms_payment_modes",
        pm_id: 58
      }).catch(() => ({ data: { status: false, Records: [] } }));

      Promise.all([activeRequest, elCinemaRequest])
        .then(([activeResponse, elCinemaResponse]) => {
          const activeData = activeResponse.data || {};
          const elCinemaData = elCinemaResponse.data || {};
          if (!activeData.status) {
            this.$toasted.show(activeData.message || "Opps! Something went wrong");
            return;
          }

          const paymentList = activeData.Records || [];
          const elCinemaMode = (elCinemaData.Records || []).find(
            mode => String(mode.pm_id) === "58"
          );
          const alreadyListed = paymentList.some(
            item => String(item.pm_id) === "58"
          );

          if (!alreadyListed) {
            paymentList.push({
              ...(elCinemaMode || {}),
              pm_id: 58,
              pm_payment_mode: "El Cinema"
            });
          }

          this.paymentList = paymentList.sort((a, b) =>
            a.pm_payment_mode.localeCompare(b.pm_payment_mode)
          );
        })
        .catch(() => {
          this.$toasted.show("Opps! Something went wrong");
        });
    },
    getActiveMovies: function () {
      this.MovieList = [];
      let payload = {
        movieversions: "N",
      };
      MovieService.GetActiveMoviesWithFormat(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if(data.Records.length){
              let updateList=data.Records.map((ele)=>{
                return {
                  ...ele,
                  movie_title_2:`${ele.movie_title}(${ele.mf_name})`
                }
              })
              this.MovieList=updateList
            }
            // data.Records.length > 0 ? (this.MovieList = data.Records) : "";
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    fetchDistributorMovies() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        let payload = {
           fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            cinema_address: this.dropDown.selectedCinemaAddres,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map(x => x.d_company_name)
            .join(","),
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date"
        };
        ReportService.GetDistributorMovieFormat(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              // this.MovieList = data.Records;
     this.MovieList = data.Records.sort((a, b) => 
  a.movie_title.toLowerCase().localeCompare(b.movie_title.toLowerCase())
);
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch(error => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState"
    ])
    },
  };
  </script>
  
  <style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }
  
  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  
  .swc-report-table th {
    border: 1px solid black !important;
  }
  
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .rtl-table {
    direction: rtl;
    text-align: right;
  }
  .rtl-table-scroll {
    direction: rtl;
  }
  .text_right {
    text-align: right;
  }
  .reverse-order {
    direction: rtl;
  }
  .order {
    direction: ltr;
  }
  .blue-background {
    background-color: #edf3fb;
  }
  .dark-blue {
    background-color: #d4e3f5;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/movieOverallAnalysisReport.vue